import {type PrepareAction, createAction} from "@reduxjs/toolkit";
import {type UserMessage, UserMessageType} from "./types";

const getId = (function () {
  let counter = 1;
  return () => counter++;
})();

export const errorUserMessage = createAction<PrepareAction<UserMessage>>(
  "messages/displayUserMessage",
  function prepare(message: string, title: string = "Error!") {
    return {
      payload: {
        message,
        title,
        id: getId(),
        type: UserMessageType.error
      }
    };
  }
);

export const successUserMessage = createAction<PrepareAction<UserMessage>>(
  "messages/displayUserMessage",
  function prepare(message: string, title: string = "Success!") {
    return {
      payload: {
        message,
        title,
        id: getId(),
        type: UserMessageType.success
      }
    };
  }
);

export const infoUserMessage = createAction<PrepareAction<UserMessage>>(
  "messages/displayUserMessage",
  function prepare(message: string) {
    return {
      payload: {
        message,
        id: getId(),
        type: UserMessageType.info
      }
    };
  }
);
